/* Page coussin gel Selmyo — comportement repris de vivelan.fr (galerie, offres, tiroir panier…) */
(() => {
  // r absent ou vide (ex. accueil sans bloc d'achat) → toute la page
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => [...(r || document).querySelectorAll(s)];
  const page = $('.vg-page');
  if (!page) return;

  const euros = (c) => {
    const e = c / 100;
    return (Number.isInteger(e) ? e : e.toFixed(2).replace('.', ',')) + ' €';
  };

  /* ── Menu (burger) ─────────────────────────────────────────── */
  const menu = $('#vv-menu-drawer');
  $('.vv-header__burger')?.addEventListener('click', () => menu?.showModal());
  menu?.addEventListener('click', (e) => {
    if (e.target === menu || e.target.closest('.vv-drawer__close')) menu.close();
  });

  /* ── Galerie ───────────────────────────────────────────────── */
  $$('[data-vv-gallery]').forEach((gallery) => {
    const slides = $$('[data-vv-slide]', gallery);
    const thumbs = $$('[data-vv-thumb]', gallery);
    const strip = $('.vv-pmain__thumbs', gallery);
    let current = 0;
    const quiet = (s) => {
      const v = $('[data-vv-pvideo]', s);
      if (!v) return;
      v.pause(); v.muted = true; s.classList.remove('is-unmuted');
    };
    const select = (i) => {
      const n = slides.length;
      current = ((i % n) + n) % n;
      slides.forEach((s, j) => {
        s.classList.toggle('is-active', j === current);
        if (j !== current) quiet(s);
        else $('[data-vv-pvideo]', s)?.play().catch(() => {});
      });
      thumbs.forEach((t, j) => t.classList.toggle('is-active', j === current));
      const t = thumbs[current];
      if (strip && t) strip.scrollTo({ left: t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
    };
    gallery.selectSlide = select;
    thumbs.forEach((t, j) => t.addEventListener('click', () => select(j)));
    $$('[data-vv-nav]', gallery).forEach((b) => b.addEventListener('click', () => select(current + parseInt(b.dataset.vvNav, 10))));
    // son des vidéos : toucher la vidéo active coupe / remet le son
    slides.forEach((s) => {
      const v = $('[data-vv-pvideo]', s);
      if (!v) return;
      s.addEventListener('click', () => {
        if (swiped) return;
        if (v.muted) { v.muted = false; v.currentTime = 0; s.classList.add('is-unmuted'); v.play().catch(() => {}); }
        else { v.muted = true; s.classList.remove('is-unmuted'); }
      });
    });
    // glisser pour changer d'image
    const main = $('.vv-pmain__main', gallery);
    let startX = null, swiped = false;
    main?.addEventListener('pointerdown', (e) => { if (!e.target.closest('[data-vv-nav]')) { startX = e.clientX; swiped = false; } });
    main?.addEventListener('pointerup', (e) => {
      if (startX === null) return;
      const dx = e.clientX - startX; startX = null;
      if (Math.abs(dx) < 40) return;
      swiped = true; setTimeout(() => (swiped = false), 50);
      select(current + (dx < 0 ? 1 : -1));
    });
    main?.addEventListener('pointercancel', () => (startX = null));
    // ouvrir la photo en grand
    const lb = $('[data-vv-lightbox]');
    if (lb) {
      const imgs = slides.map((s, j) => ({ j, src: s.dataset.vvLbSrc })).filter((x) => x.src);
      const lbImg = $('[data-vv-lb-img]', lb);
      const counter = $('[data-vv-lb-counter]', lb);
      let k = 0;
      const show = (i) => {
        k = ((i % imgs.length) + imgs.length) % imgs.length;
        lbImg.src = imgs[k].src;
        lbImg.classList.remove('is-zoomed');
        if (counter) counter.textContent = `${k + 1} / ${imgs.length}`;
      };
      slides.forEach((s, j) => {
        if (!s.dataset.vvLbSrc) return;
        s.addEventListener('click', () => {
          if (swiped) return;
          show(imgs.findIndex((x) => x.j === j)); lb.showModal();
        });
      });
      lb.addEventListener('click', (e) => {
        if (e.target.closest('[data-vv-lb-close]') || e.target === lb) return lb.close();
        const nav = e.target.closest('[data-vv-lb-nav]');
        if (nav) return show(k + parseInt(nav.dataset.vvLbNav, 10));
        if (e.target === lbImg) lbImg.classList.toggle('is-zoomed');
      });
      let lx = null;
      lb.addEventListener('pointerdown', (e) => (lx = e.clientX));
      lb.addEventListener('pointerup', (e) => {
        if (lx === null) return;
        const dx = e.clientX - lx; lx = null;
        if (Math.abs(dx) > 50) show(k + (dx < 0 ? 1 : -1));
      });
    }
    select(0);
  });

  /* ── Offres (1 coussin / 1 + 1 offert) ─────────────────────── */
  const root = $('.vv-pmain');
  const form = $('#vg-product-form');
  const qtyInput = $('[data-vv-form-qty]');
  const atc = $('.vv-pmain__atc');
  const resolve = () => {
    const r = $('.vv-pmain__offer-input:checked', root);
    if (!r) return;
    if (qtyInput) qtyInput.value = r.dataset.quantity;
    const txt = r.dataset.priceText;
    const tot = parseInt(r.dataset.totalCents, 10);
    const cmp = parseInt(r.dataset.compareCents, 10) || 0;
    $$('[data-vv-atc-price],[data-vv-sticky-price],[data-vv-pr-price],[data-vv-dynprice]', root).forEach((el) => (el.textContent = txt));
    $$('[data-vv-dynqty]', root).forEach((el) => (el.textContent = r.dataset.quantity));
    const pc = $('[data-vv-pr-compare]', root);
    if (pc) { pc.hidden = cmp <= tot; pc.textContent = cmp > tot ? euros(cmp) : ''; }
  };
  $('[data-vv-offers]')?.addEventListener('change', resolve);
  resolve();

  /* ── Barre collée en bas : visible quand le bouton principal est passé ── */
  const sticky = $('[data-vv-sticky]');
  if (sticky && atc) {
    const check = () => { sticky.hidden = atc.getBoundingClientRect().bottom > 0; };
    window.addEventListener('scroll', check, { passive: true });
    check();
    $('[data-vv-sticky-btn]', sticky).addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.submit());
  }
  // bouton de la garantie : même ajout que le bouton principal
  $$('[data-vv-add]').forEach((b) => b.addEventListener('click', (e) => {
    e.preventDefault();
    form.requestSubmit ? form.requestSubmit() : form.submit();
  }));

  /* ── Dates de livraison : expédition J+1 à J+2, réception J+4 à J+6, dimanches non comptés ── */
  $$('[data-vv-delivery]').forEach((box) => {
    const add = (from, days) => { const d = new Date(from); let l = days; while (l > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) l--; } return d; };
    const fmt = (d) => d.toLocaleDateString('fr', { day: 'numeric', month: 'long' });
    const range = (a, b) => (fmt(a) === fmt(b) ? fmt(a) : fmt(a) + ' – ' + fmt(b));
    const t = new Date();
    const set = (k, v) => { const el = $(`[data-vv-date="${k}"]`, box); if (el) el.textContent = v; };
    set('ordered', fmt(t));
    set('shipped', range(add(t, 1), add(t, 2)));
    set('delivered', range(add(t, 4), add(t, 6)));
  });

  /* ── Compte à rebours de l'offre (jusqu'à minuit) ───────────── */
  const boxes = $$('[data-vv-offer-countdown]');
  if (boxes.length) {
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const now = new Date();
      const end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
      const l = Math.max(0, Math.floor((end - now) / 1000));
      boxes.forEach((b) => { const v = $('[data-vv-offer-countdown-value]', b); if (v) v.textContent = `${pad(Math.floor(l / 3600))}:${pad(Math.floor((l % 3600) / 60))}:${pad(l % 60)}`; });
    };
    tick(); setInterval(tick, 1000);
  }

  /* ── Mini-avis sous le bloc d'achat ─────────────────────────── */
  $$('[data-vv-minirev]').forEach((box) => {
    const cards = $$('.vv-pmain__minirev-card', box);
    const dots = $$('[data-vv-minirev-dot]', box);
    if (cards.length < 2) return;
    let i = 0;
    const show = (n) => { i = ((n % cards.length) + cards.length) % cards.length; cards.forEach((c, j) => c.classList.toggle('is-active', j === i)); dots.forEach((d, j) => d.classList.toggle('is-active', j === i)); };
    dots.forEach((d) => d.addEventListener('click', () => show(parseInt(d.dataset.vvMinirevDot, 10))));
    const track = $('.vv-pmain__minirev-track', box);
    let sx = null;
    track.addEventListener('pointerdown', (e) => (sx = e.clientX));
    track.addEventListener('pointerup', (e) => { if (sx === null) return; const d = e.clientX - sx; sx = null; if (Math.abs(d) > 40) show(i + (d < 0 ? 1 : -1)); });
  });

  /* ── Vidéos : lecture quand elles sont à l'écran (muettes), pause sinon ── */
  const visible = (el) => { const r = el.getBoundingClientRect(); return r.bottom > 0 && r.top < innerHeight && r.width > 0; };
  const autoVideos = () => $$('[data-vv-lazy-video], [data-vv-vtest] [data-vv-video]');
  const playVisible = () => autoVideos().forEach((v) => {
    if (visible(v)) { if (v.paused) { if (v.readyState === 0) v.load(); v.play().catch(() => {}); } }
    else if (!v.paused) { v.pause(); if (!v.muted) { v.muted = true; v.closest('.vv-vtest__frame')?.classList.remove('is-unmuted'); } }
  });
  autoVideos().forEach((v) => { v.muted = true; v.playsInline = true; v.removeAttribute('loading'); });
  window.addEventListener('scroll', playVisible, { passive: true });
  setTimeout(playVisible, 300);

  /* ── Carrousel des vidéos d'avis ────────────────────────────── */
  $$('[data-vv-vtest]').forEach((wrap) => {
    const sc = $('[data-vv-vtest-scroller]', wrap) || wrap;
    const vids = $$('[data-vv-video]', sc);
    const prev = $('[data-vv-vtest-prev]', wrap), next = $('[data-vv-vtest-next]', wrap);
    const step = () => { const it = $('.vv-vtest__item', sc); return it ? it.getBoundingClientRect().width + 16 : sc.clientWidth * 0.7; };
    const sync = () => {
      const max = sc.scrollWidth - sc.clientWidth;
      [prev, next].forEach((b) => b && (b.hidden = max <= 4));
      if (prev) prev.disabled = sc.scrollLeft <= 4;
      if (next) next.disabled = sc.scrollLeft >= max - 4;
    };
    prev?.addEventListener('click', () => sc.scrollBy({ left: -step(), behavior: 'smooth' }));
    next?.addEventListener('click', () => sc.scrollBy({ left: step(), behavior: 'smooth' }));
    sc.addEventListener('scroll', () => { sync(); playVisible(); }, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
    sc.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-vv-video-btn]');
      if (!btn) return;
      const v = $('[data-vv-video]', btn);
      if (!v) return;
      const was = !v.muted;
      vids.forEach((o) => { o.muted = true; o.closest('.vv-vtest__frame')?.classList.remove('is-unmuted'); });
      if (was) { v.pause(); return; }
      v.muted = false; v.currentTime = 0; btn.classList.add('is-unmuted');
      v.play().catch(() => { v.muted = true; btn.classList.remove('is-unmuted'); });
    });
  });

  /* ── Avis : 6 visibles, « Voir plus d'avis » ───────────────── */
  $$('[data-vv-reviews]').forEach((s) => {
    const cards = $$('.vv-reviews__card', s);
    const more = $('[data-vv-more]', s);
    let open = false;
    const apply = () => { cards.forEach((c, i) => (c.hidden = !open && i >= 6)); if (more) more.hidden = open || cards.length <= 6; };
    more?.addEventListener('click', () => { open = true; apply(); });
    apply();
  });

  /* ── Tiroir panier ──────────────────────────────────────────── */
  const drawer = $('#vv-cart-drawer');
  const lines = $('[data-vg-lines]', drawer);
  const cadeaux = (page.dataset.vgCadeaux || '').split(',').map((p) => parseInt(p, 10)).filter(Boolean);
  const comparePrix = {};
  const compareOf = async (item) => {
    if (comparePrix[item.handle] === undefined) {
      try {
        const p = await fetch(`/products/${item.handle}.js`).then((r) => r.json());
        p.variants.forEach((v) => (comparePrix[item.handle + ':' + v.id] = v.compare_at_price || 0));
        comparePrix[item.handle] = true;
      } catch (e) { comparePrix[item.handle] = false; }
    }
    return comparePrix[item.handle + ':' + item.variant_id] || 0;
  };
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const img = (u) => (u ? u + (u.includes('?') ? '&' : '?') + 'width=200' : '');
  const trash = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="M19 6l-1 14H6L5 6"/><path d="M10 11v6M14 11v6"/></svg>';

  // compte à rebours de réservation (10 min, ne repart pas sous les yeux du client)
  const KEY = 'vg-cart-deadline', MS = 10 * 60 * 1000, PAUSE = 2 * 60 * 60 * 1000;
  let tickT = null;
  const rd = () => { try { return parseInt(localStorage.getItem(KEY) || '0', 10) || 0; } catch (e) { return 0; } };
  const syncTimer = (count) => {
    const now = Date.now(); let d = rd();
    try {
      if (count > 0) { if (!(d && now < d) && !(d && now < d + PAUSE)) { d = now + MS; localStorage.setItem(KEY, String(d)); } }
      else { localStorage.removeItem(KEY); d = 0; }
    } catch (e) {}
    if (tickT) clearInterval(tickT);
    const box = $('[data-vv-cart-timer]', drawer);
    if (!box) return;
    const render = () => {
      const l = d - Date.now();
      if (!d || l <= 0) { box.hidden = true; if (tickT) clearInterval(tickT); return; }
      box.hidden = false;
      $('[data-vv-timer-value]', box).textContent = `${Math.floor(l / 60000)}:${String(Math.floor((l % 60000) / 1000)).padStart(2, '0')}`;
    };
    render(); tickT = setInterval(render, 1000);
  };

  const ligne = async (it, enfant) => {
    const cmpU = await compareOf(it);
    const barreLigne = Math.max(it.original_line_price, cmpU * it.quantity);
    const lot = it.properties && it.properties._is_bundle;
    const titre = it.product_title.replace(/\s+Selmyo$/, '');
    let prix;
    if (enfant) {
      prix = `<span class="vv-cart-item__price">${barreLigne > it.final_line_price ? `<s class="vv-cart-item__price-original">${euros(barreLigne)}</s>` : ''}${it.final_line_price === 0 ? '<span class="vv-cart-item__free">Offert</span>' : euros(it.final_line_price)}</span>`;
    } else {
      prix = `<span class="vv-cart-item__price">${barreLigne > it.final_line_price ? `<s class="vv-cart-item__price-original">${euros(barreLigne)}</s>` : ''}${euros(it.final_line_price)}</span>`;
    }
    const lien = `${it.url}`;
    const bas = enfant ? '' : (lot
      ? `<div class="vv-cart-item__row"><button type="button" class="vv-cart-item__trash" data-vv-qty data-key="${it.key}" data-quantity="0" aria-label="Retirer le pack du panier">${trash}</button></div>`
      : `<div class="vv-cart-item__row"><div class="vv-cart-item__qty"><button type="button" data-vv-qty data-key="${it.key}" data-quantity="${it.quantity - 1}" aria-label="Réduire la quantité">−</button><span>${it.quantity}</span><button type="button" data-vv-qty data-key="${it.key}" data-quantity="${it.quantity + 1}" aria-label="Augmenter la quantité">+</button></div></div>`);
    return `<div class="vv-cart-item vv-cart-item--drawer${enfant ? ' vv-cart-item--child' : ''}"><a href="${lien}" class="vv-cart-item__media"><img src="${img(it.image)}" alt="" width="200" height="200" loading="lazy" class="vv-cart-item__img"><span class="vv-cart-item__qty-badge" aria-hidden="true">${it.quantity}</span></a><div class="vv-cart-item__body"><div class="vv-cart-item__top"><a href="${lien}" class="vv-cart-item__title">${esc(titre)}</a>${prix}</div>${bas}</div></div>`;
  };

  let panier = null;
  const refresh = async (open) => {
    panier = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    const parents = panier.items.filter((i) => !(i.parent_relationship && i.parent_relationship.parent_key));
    const html = [];
    for (const p of parents) {
      html.push(await ligne(p, false));
      for (const c of panier.items.filter((i) => i.parent_relationship && i.parent_relationship.parent_key === p.key)) html.push(await ligne(c, true));
    }
    lines.innerHTML = html.join('');
    const count = parents.reduce((n, i) => n + i.quantity, 0);
    $('[data-vg-empty]', drawer).hidden = panier.items.length > 0;
    $('.vv-cart-drawer__footer', drawer).hidden = panier.items.length === 0;
    $('.vv-cart-drawer__reassurance', drawer).hidden = panier.items.length === 0;
    const sub = panier.items.reduce((n, i) => n + i.original_line_price, 0);
    const disc = sub - panier.total_price;
    $('[data-vg-sub]', drawer).textContent = euros(sub);
    $('[data-vg-disc-line]', drawer).hidden = disc <= 0;
    $('[data-vg-disc]', drawer).textContent = '− ' + euros(disc);
    $$('[data-vg-total]', drawer).forEach((el) => (el.textContent = euros(panier.total_price)));
    $$('[data-vg-checkout]', drawer).forEach((el) => (el.textContent = 'Commander — ' + euros(panier.total_price)));
    drawer.dataset.cartCount = count;
    $$('[data-vv-cart-count]').forEach((el) => { el.textContent = count; el.hidden = count === 0; });
    syncTimer(count);
    if (open && !drawer.open) drawer.showModal();
  };

  // phase de capture : d'autres scripts du thème arrêtent les clics sur les liens « /cart »
  window.addEventListener('click', async (e) => {
    if (e.target.closest('[data-vv-open-cart]')) {
      e.preventDefault(); e.stopImmediatePropagation();
      if (!drawer.open) drawer.showModal();
      await refresh(false);
      return;
    }
    if (e.target.closest('[data-vv-close-cart]') || e.target === drawer) { drawer.close(); return; }
    const q = e.target.closest('[data-vv-qty]');
    if (q) {
      e.preventDefault();
      if (q.disabled) return;
      q.disabled = true;
      try {
        const qty = parseInt(q.dataset.quantity, 10);
        const updates = { [q.dataset.key]: qty };
        // retirer le coussin retire aussi ses cadeaux
        if (qty === 0 && panier) panier.items.forEach((i) => {
          if ((i.parent_relationship && i.parent_relationship.parent_key === q.dataset.key) || cadeaux.includes(i.variant_id)) updates[i.key] = 0;
        });
        await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
        await refresh(false);
      } finally { q.disabled = false; }
    }
  }, true);

  // écoute en premier (phase de capture) : sinon le script Shopify « standard-actions » prend l'ajout au panier
  window.addEventListener('submit', async (e) => {
    const f = e.target;
    if (!(f instanceof HTMLFormElement)) return;
    if (e.submitter && e.submitter.name === 'checkout') { e.submitter.classList.add('is-loading'); return; }
    if (f !== form) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const btn = $('[type="submit"]', f);
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    try {
      const data = new FormData(f);
      const offre = $('.vv-pmain__offer-input:checked', root);
      const g = (offre?.dataset.gifts || '').trim();
      const id = parseInt(data.get('id'), 10);
      const qty = parseInt(data.get('quantity') || '1', 10);
      if (g) {
        const kids = g.split(',').map((p) => { const [a, b] = p.split(':'); return { id: parseInt(a, 10), quantity: parseInt(b, 10) || 1 }; }).filter((x) => x.id);
        let r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id, quantity: qty, properties: { _is_bundle: 'true' } }, ...kids.map((k) => ({ ...k, parent_id: id }))] }) });
        if (!r.ok) {
          // si le panier refuse les lignes liées : on ajoute tout simplement
          await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id, quantity: qty, properties: { _is_bundle: 'true' } }, ...kids] }) });
        }
      } else {
        await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id, quantity: qty }] }) });
      }
      await refresh(true);
    } finally {
      if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); }
    }
  }, true);
  window.addEventListener('pageshow', (e) => { if (e.persisted) $$('.is-loading').forEach((b) => { b.classList.remove('is-loading'); b.disabled = false; }); });

  // arrivée depuis un lien « panier » (?cd=panier, ex. retour de la page de paiement) : tiroir ouvert
  refresh(new URLSearchParams(location.search).get('cd') === 'panier').catch(() => {});
})();
